import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import Heading from '../Typography/Heading/Heading';
import SubHeading from '../Typography/SubHeading/SubHeading';
import {
  accountTypes,
  isTrust,
  isTrustExistingFlow
} from '../../flows/shared/utils.ts';
import { getConfirmationHeading, getConfirmationSubHeading } from './util';

const ConfirmationHeading = () => {
  const { appState } = useContext(FlowContext);

  const {
    store: {
      accountType,
      app: { fundingMethodType }
    }
  } = appState;

  const isRollover = accountType === accountTypes.ROLLOVER;
  const isExistingTrust = isTrustExistingFlow(accountType, fundingMethodType);

  return isTrust(accountType) ? (
    <>
      <Heading
        text={
          isExistingTrust
            ? 'Nice work - now complete these steps so we can finalize your transfer'
            : "Nice work - now let's activate your account"
        }
      />
      <SubHeading
        text={
          isExistingTrust
            ? `Send in your change of ownership form and trust document.`
            : 'Send us your check, check form, and trust document as soon as possible'
        }
      />
      <SubHeading text="A confirmation email is on its way." />
    </>
  ) : (
    <>
      <Heading text={getConfirmationHeading(appState, isRollover)} />
      <SubHeading text={getConfirmationSubHeading(appState)} />
    </>
  );
};

export default ConfirmationHeading;
